module.exports = __webpack_public_path__ + "img/programme1.7215fd29.png";